import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreText?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  moreTo,
  moreText,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-block rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            {eyebrow}
          </span>
        )}
        <h2 className="font-display text-2xl text-foreground-900 md:text-3xl">{title}</h2>
        {desc && <p className="mt-2 max-w-2xl text-sm text-foreground-600">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border border-primary-300 px-4 py-2 text-sm text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
        >
          {moreText || "查看全部"}
          <i className="ri-arrow-right-line text-sm"></i>
        </Link>
      )}
    </div>
  );
}